import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
export class TabsCardStylingModel extends CoreStylingModel {
/**
 * Styling of label
 */
label?: StylingModel;
/**
 * Styling of icon index
 */
iconIndex?: StylingModel;
/**
 * Styling of prefix Index
 */
prefixIndex?: StylingModel;
/**
 * @hidden 
 * It is the constructor for the TabsCardStylingModel. It takes the values to create the TabsCardStylingModel object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function TabsCardStylingModel_tsickle_Closure_declarations() {
/**
 * Styling of label
 * @type {?}
 */
TabsCardStylingModel.prototype.label;
/**
 * Styling of icon index
 * @type {?}
 */
TabsCardStylingModel.prototype.iconIndex;
/**
 * Styling of prefix Index
 * @type {?}
 */
TabsCardStylingModel.prototype.prefixIndex;
}

